import { Autocomplete, TextField, Typography } from "@mui/material"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IFieldAutoCompleteProps<T extends string | number | null> {
  id: string
  label: string
  options: T[]
  value: T | T[]
  isMultiple?: boolean
  sx?: any
  error?: string
  disabled?: boolean
  required?: boolean
  fullWidth?: boolean
  optionLabelFn(value: T): string
  onChange(newValue: T | T[]): any
  onBlur?(): any
}

export const FieldAutoComplete = React.memo(
  ({
    id,
    label,
    options: filters,
    value,
    error,
    sx,
    disabled,
    isMultiple,
    required,
    fullWidth,
    optionLabelFn,
    onChange,
    onBlur
  }: IFieldAutoCompleteProps<string | number | null>): JSX.Element => (
    <FlexBox vertical>
      <Autocomplete
        sx={{ ...sx, "& input": { fontSize: ".8rem", pr: "1.8rem !important" } }}
        size={isMultiple ? undefined : "small"}
        id={id}
        fullWidth={fullWidth}
        multiple={isMultiple}
        options={filters}
        disabled={disabled}
        getOptionLabel={option => optionLabelFn(option) || "-"}
        value={value}
        filterSelectedOptions
        renderOption={
          isMultiple
            ? undefined
            : (props, option) => (
                <li {...props} key={`listItem-${option}`}>
                  {optionLabelFn(option) || "-"}
                </li>
              )
        }
        disableClearable={required}
        onChange={(_event, newValue) => onChange(newValue)}
        renderInput={params => (
          <TextField {...params} required={required} label={label} error={typeof error === "string" && error !== ""} />
        )}
        onBlur={() => (onBlur ? onBlur() : undefined)}
      />
      {error && (
        <Typography color="error" sx={{ width: "100%", fontSize: ".75rem", mt: ".3rem", ml: "1rem" }}>
          {error}
        </Typography>
      )}
    </FlexBox>
  )
)
